const __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"https://api.grifin-app.com","environment":"production"};